import Link from './Link'
import OutboundLink from './OutboundLink'

export { Link, OutboundLink }
